import React from "react";

import { CONSULTATION, CONTACT_DETAILS, SHOWROOM } from "../../data/content";
import { WhatsAppIcon } from "../general/Icons";
import PageHero from "../general/PageHero";
import PageMeta from "../general/PageMeta";

const Showroom = () => {
  return (
    <React.Fragment>
      <PageMeta title={"Showroom"} />
      <PageHero />

      <section className={"intro showroom-intro"}>
        <h1 className={"section-title"}>{SHOWROOM.TITLE}</h1>
        <p className={"body-text"}>{SHOWROOM.TEXT}</p>
        <address className={"showroom-address"}>
          <a
            href={CONTACT_DETAILS.MAP_LINK}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {CONTACT_DETAILS.ADDRESS.join(" ")}
          </a>
        </address>
        <a
          href={CONTACT_DETAILS.WHATSAPP_LINK}
          className={"btn is-wide"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          <WhatsAppIcon />
          {CONSULTATION.BUTTON}
        </a>
      </section>
    </React.Fragment>
  );
};

export default Showroom;
